export const GST_RATE = 0.10;

export const SERVICE_CATEGORIES = [
  {
    id: "wheels",
    category: "Wheel Services",
    code: "01",
    description: "Factory-grade alloy refurbishing, custom two-tone finishes and full blackout coats.",
    items: [
      { name: "Rim Refurb", price: 125, unit: "per wheel", desc: "Kerb damage repair, sanding and factory colour match." },
      { name: "Rim Refurb (2 Colours)", price: 135, unit: "per wheel", desc: "Kerb damage repair, sanding and factory colour match on 2 tone rims." },
      { name: "Rim Blackout", price: 200, unit: "per wheel", desc: "Full gloss, satin or matte stealth-black finish." },
      { name: "Rim Respray", price: 125, unit: "per wheel", desc: "Full respray — stripped, prepped and refinished in your choice of colour." },
    ],
  },
  {
    id: "steering",
    category: "Steering Wheel Services",
    code: "02",
    description: "Ergonomic leather rewrapping, soft-peel restoration and OEM texture repairs.",
    items: [
      { name: "SW Repair", price: 80, unit: "per wheel", desc: "From minor tears, worn leather or blown out steering wheels — OEM finish look." },
      { name: "SW Soft Peel", price: 100, unit: "per wheel", desc: "Sticky OEM coating stripped, durable finish re-applied." },
      { name: "SW Rewrap", price: 250, unit: "per wheel", desc: "Custom perforated or Nappa leather rewrap with stitching." },
      { name: "Suede Clean", price: 60, unit: "per wheel", desc: "Grime build up on suede grips deep cleaned and revived to factory texture." },
    ],
  },
  {
    id: "interior",
    category: "Interior & Trim Restoration",
    code: "03",
    description: "Precision cabin restoration — pillars, carpets, vinyl welds and seat re-dyeing.",
    items: [
      { name: "Pillars (Set)", price: 70, unit: "per set", desc: "Exterior A, B, C pillars restored of sun fade, acid stain, water staining — OEM finish." },
      { name: "Belt Moulds", price: 60, unit: "per set", desc: "Window belt-line moulding rejuvenation and blackout." },
      { name: "Cargo Grain", price: 150, unit: "full area", desc: "Rear cargo texture restoration with protective coating." },
      { name: "Metallics", price: 70, unit: "per trim", desc: "Brushed metallic and satin aluminium trim refinishing." },
      { name: "Vinyl Weld", price: 50, unit: "spot repair", desc: "Structural crack welding and colour match on leather panels and seats." },
      { name: "Seat Paints", price: 60, unit: "per panel", desc: "High-durability OEM leather and vinyl paint applied." },
      { name: "Carpet Velour", price: 50, unit: "per section", desc: "Burn hole, tear and velour fibre reconstruction." },
      { name: "Heelmat", price: 50, unit: "per install", desc: "Heavy-duty reinforced rubber heelmat install." },
      { name: "Grab Handles (BMW)", price: 60, unit: "per set", desc: "Sticky-melt BMW door grab handle restoration." },
    ],
  },
  {
    id: "lighting",
    category: "Lighting & Accessories",
    code: "04",
    description: "Crystal-clear headlight lens restoration, UV hardcoat sealing and machining.",
    items: [
      { name: "Headlights", price: 90, unit: "per pair", desc: "Dual stage oxidisation removal, wet sand finished with UV protected ceramic coating." },
      { name: "Headlights (Machined)", price: 115, unit: "per pair", desc: "Dual stage oxidisation removal, precision wet sand finished with UV protected ceramic coating." },
    ],
  },
];

export const ALL_SERVICES = SERVICE_CATEGORIES.flatMap((c) =>
  c.items.map((i) => ({ ...i, category: c.category }))
);

export const BUSINESS = {
  name: "Elite Rims & Trims",
  tagline: "Premium Wheel Refurbishment & Interior Restoration Services",
  phone: "0459440803",
  email: "Eliterimstrims@gmail.com",
};
